import { render, staticRenderFns } from "./NotificationsContent.vue?vue&type=template&id=6824da76&"
import script from "./NotificationsContent.vue?vue&type=script&lang=js&"
export * from "./NotificationsContent.vue?vue&type=script&lang=js&"
import style0 from "./NotificationsContent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports